var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3c8dc61f66dc9928700db452a36dcc3d1bde2450"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tmc-web@trymycar-0d"]={id:"3c8dc61f66dc9928700db452a36dcc3d1bde2450"};
      